import React, { Component } from "react";
import { Col } from "react-flexbox-grid";
import { TextField, SelectField } from "components/support";
import { RadioButton, RadioButtonGroup } from "material-ui/RadioButton";
import RadioButtonChecked from "material-ui/svg-icons/toggle/radio-button-checked";
import RadioButtonUnchecked from "material-ui/svg-icons/toggle/radio-button-unchecked";
import styles from "../styles";

class Field extends Component {
  handleCreatedField() {
    if (this.props.type === "simple_text") {
      return (
        <TextField
          fullWidth
          underlineShow={false}
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    } else if (this.props.type === "large_text") {
      return (
        <TextField
          multiLine
          rows={5}
          underlineShow={false}
          fullWidth
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    } else if (this.props.type === "phone") {
      return (
        <TextField
          maskPattern={[
            "(",
            /\d/,
            /\d/,
            ")",
            " ",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            "-",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]}
          fullWidth
          underlineShow={false}
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    } else if (this.props.type === "date") {
      return (
        <TextField
          maskPattern={[
            /\d/,
            /\d/,
            "/",
            /\d/,
            /\d/,
            "/",
            /\d/,
            /\d/,
            /\d/,
            /\d/
          ]}
          fullWidth
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    } else if (this.props.type === "hour") {
      return (
        <TextField
          maskPattern={[/\d/, /\d/, ":", /\d/, /\d/]}
          fullWidth
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    } else if (this.props.type === "list") {
      return (
        <SelectField
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          underlineStyle={{ bottom: "0" }}
          labelStyle={{ height: "44px" }}
          fullWidth
          options={this.props.options}
        />
      );
    } else if (this.props.type === "radiobutton") {
      return (
        <div>
          <p style={styles.labelRadioButton}>{this.props.name}:</p>
          <RadioButtonGroup
            name={this.props.name}
            onChange={this.props.onValueChange}
            style={styles.rootRadioButtonGroup}
            defaultSelected={this.props.value}
          >
            {this.props.optionsForRadioButton.map((option, index) => (
              <RadioButton
                key={index + 1}
                value={option}
                label={option}
                labelStyle={styles.labelOptionRadioButton}
                checkedIcon={
                  <RadioButtonChecked style={styles.colorRadioButton} />
                }
                uncheckedIcon={
                  <RadioButtonUnchecked
                    style={styles.colorUncheckedRadioButton}
                  />
                }
                style={styles.rootRadioButton}
              />
            ))}
          </RadioButtonGroup>
        </div>
      );
    } else {
      return (
        <TextField
          maskPattern={[
            /\d/,
            /\d/,
            "/",
            /\d/,
            /\d/,
            "/",
            /\d/,
            /\d/,
            /\d/,
            /\d/,
            " ",
            " ",
            /\d/,
            /\d/,
            ":",
            /\d/,
            /\d/
          ]}
          fullWidth
          floatingLabelFixed
          floatingLabelText={this.props.name}
          value={this.props.value}
          onChange={this.props.onValueChange}
          errorText={this.props.errorText}
        />
      );
    }
  }

  render() {
    return (
      <Col xs={12} md={6}>
        {this.handleCreatedField()}
      </Col>
    );
  }
}

export default Field;



// WEBPACK FOOTER //
// ./src/components/app/registration/customer/form/custom-info/fields/index.jsx